
import { useAuth } from '@common/auth/use-auth';
import {Trans} from '@common/i18n/trans';
import { useTrans } from '@common/i18n/use-trans';
import { Button } from '@common/ui/buttons/button';
import React, {Fragment, useCallback, useEffect, useState} from 'react';
import { TextField } from '@common/ui/forms/input-field/text-field/text-field';
import {Item} from '@common/ui/forms/listbox/item';

import {SubmitHandler, UseFormReturn, useForm} from 'react-hook-form';
import {Form} from '@common/ui/forms/form';
import { FormSelect } from '@common/ui/forms/select/select';
import { useSettings } from '@common/core/settings/use-settings';
import { UwDemo } from './uw';
import { FileWithPath, useDropzone } from 'react-dropzone';

import { formatBytes } from '@common/utils/number/byte-format';
import { ViewDemoLayout } from './view-demo-layout';
import { useDemoUw } from '@app_modules/requests/use-demo-uw';
import { SourceRowUw } from './uw-source-row';
import { getCookie } from '@common/utils/hooks/use-cookie';
import AppraisalReviewCard from './uw-demo-chat-card';
import { useMyHtml } from '@app_modules/requests/use-my-html';
import { queryClient } from '@common/http/query-client';


export function UwDemoPage() {
  const {trans} = useTrans();
  const {user} = useAuth();
  
  const [item, setItem] = useState<any>([]);
  const [message, setMessage] = useState('');
  const report_id = getCookie(`demo-uw-report_id`);
  const [reportId, setReportId] = useState(report_id);

  const onHeaderClick = () => {
    debugger;
  };

  const updateItem = (result: any) => {
    if (result.message != undefined) {
      setMessage(result.message);
    }
    setItem(result);
  };

  const updateMessage = (message: string) => {
    if (message != undefined) {
      debugger;
      setMessage(message);
    }
  };

  useEffect(() => {
    if (item.message != undefined) {
      setMessage(item.message);
    }
    if (item.report_id != undefined) {
      setReportId(item.report_id);
    }
  }, [item])

  const [sources, setSources] = useState([]);

  const suggested_prompts = getCookie(`demo-uw-suggested-prompts`);
  const [suggestedPrompts, setSuggestedPrompts] = useState<string[]>(suggested_prompts ? JSON.parse(suggested_prompts) : []);
  
  useEffect(() => {
    const allSuggestedPrompts: string[] = [];
  
    sources.forEach((file_id: string) => {
      const cookieValue = getCookie(`demo-uw-sources-${file_id}`);
      
      if (cookieValue) {
        try {
          const parsed = JSON.parse(cookieValue);
          if (Array.isArray(parsed)) {
            allSuggestedPrompts.push(...parsed);
          }
        } catch (error) {
          console.error(`Failed to parse suggested prompts for file_id: ${file_id}`, error);
        }
      }
    });
  
    setSuggestedPrompts(allSuggestedPrompts);
  }, [sources]);

  return (
    <Fragment>
      <div className='flex gap-10 m-20'>
        <div className='w-[30%] pr-10 border-r-1 sticky'>
          <AddPrompt updateItem={updateItem} updateMessage={updateMessage} updateSources={setSources} updateSuggestedPrompts={setSuggestedPrompts}/>
        </div>
        <div className='w-[70%]'>
        <ViewDemoLayout
          reportId={reportId!}
          title={
            <Trans message="Findings"/>
          }
          // isLoading={viewReport.isPending}
        >
            <fieldset className="w-full border-2 border-t-2 min-h-[400px]">
            <div className="p-4">
              {/* <div
                className="loan-details-content"
                dangerouslySetInnerHTML={{ __html: message }}
              /> */}
              <iframe
                srcDoc={message} // Render HTML directly
                className="w-full h-[580px] border-0"
                sandbox="allow-same-origin" // Adjust for security
                title="Underwriting"
              />

              </div>
          </fieldset>
        </ViewDemoLayout>
        <AppraisalReviewCard report_id={reportId} sources={sources} suggestedPrompts={suggestedPrompts} updateMessage={updateMessage}/>
        </div>
      </div>
      
    </Fragment>
  );
}


// Parent component
function AddPrompt({ updateItem, updateMessage, updateSources, updateSuggestedPrompts }: { updateItem: any; updateMessage: any; updateSources: any; updateSuggestedPrompts: any}) {
  const form = useForm<UwDemo>({
    defaultValues: {
      prompt: '',
      // loan_purpose: '',
      income_type: '',
    },
  });

  const [item, setItem] = useState([]);
  const updateResult = (result: any) => {
    setItem(result);
    updateItem(result);
  };

  const sendChat = useDemoUw(form);
  return (
    <AddPromptForm
      updateSources={updateSources}
      form={form}
      onSubmit={(values) => {
        sendChat.mutate(values, {
          onSuccess: (response: any) => {
            updateResult(response);
          },
        });
      }}
      isLoading={sendChat.isPending}
      updateMessage={updateMessage}
      item={item}
      updateSuggestedPrompts={updateSuggestedPrompts}
      // changePrompt={(value: string) => form.setValue('prompt', value, { shouldDirty: true })}
    />
  );
}

// Props interface for AddPromptForm, using Prompt directly
interface Props {
  onSubmit: SubmitHandler<UwDemo>;
  form: UseFormReturn<UwDemo>;
  isLoading?: boolean;
  disableSaveWhenNotDirty?: boolean;
  updateMessage: any;
  // uploadFiles: any;
  // changePrompt: (value: string) => void;
  item: any;
  updateSources: any;
  updateSuggestedPrompts: any;

}

// AddPromptForm component
export function AddPromptForm({
  onSubmit,
  form,
  isLoading = false,
  disableSaveWhenNotDirty = false,
  updateMessage,
  item, 
  updateSources, 
  updateSuggestedPrompts
}: Props) {
  const isDirty = !disableSaveWhenNotDirty
    ? true
    : Object.keys(form.formState.dirtyFields).length;

  const { trans } = useTrans();

  const {loan} = useSettings();
  const income_types = loan?.income_types ? JSON.parse(loan.income_types):[];
  // const loan_purposes = loan?.loan_purposes ? JSON.parse(loan.loan_purposes):[];

  // const {data: product} = useMyLoanProduct();
  // const product_list = product?.product;
  const [files, setFiles] = useState([]);
  
  const onDrop = useCallback((acceptedFiles: any) => {
    setFiles(acceptedFiles);
    // uploadFiles(acceptedFiles);
	}, []);

  useEffect(() => {
      form.setValue('files', files);
  }, [form, files]);

  const report_id = getCookie(`demo-uw-report_id`);
  const [reportId, setReportId] = useState(report_id ?? '');
  const [status, setStatus] = useState('');
  const [percentage, setPercentage] = useState(0);

  
  const {data: myhtml} = useMyHtml(reportId);
  // Update message when HTML is fetched
  useEffect(() => {
    if (myhtml?.html) {
      updateMessage(myhtml.html);
    }
  }, [myhtml?.html]);
  

  useEffect(() => {
    if (item.status != undefined) {
      setStatus(item.status);
    }
    if (item.report_id != undefined) {
      setReportId(item.report_id);
    }
    if (item.percentage != undefined) {
      setPercentage(item.percentage);
    }
  }, [item]);

  useEffect(() => {
    
    window.Echo.channel('demo-uw').listen('.update', (e: any) => {
      if (e.data[reportId] != undefined) {
        const item = e.data[reportId];
        // const reportId = item.report_id;
        setReportId(reportId);
        setStatus(item.status);
        setPercentage(item.percentage);
        // if (item.message != undefined) {
        //   updateMessage(item.message);
        // }
        // Trigger refetch of HTML
        queryClient.invalidateQueries({
          queryKey: ['demo-uw-html', reportId], // matches your improved key!
        });
      }
    });
  }, [reportId])

  const [selectedFileIds, setSelectedFileIds] = useState<any[]>([]);
  const handleSelectedFileIdsChange = (pidx: number, fileIds: number[]) => {
    setSelectedFileIds(fileIds);
  };

  // useEffect(() => {
  //   setSelectedFileIds(selectedFileIds);
  // }, [selectedFileIds]);
  useEffect(() => {
    if (selectedFileIds) {
      form.setValue('sources', selectedFileIds);
    }
    updateSources(selectedFileIds);
  }, [form, selectedFileIds]);

  useEffect(() => {
    if (reportId) {
      form.setValue('report_id', reportId);
    }
  }, [form, reportId]);
  
  const handleUpdatedId = (id: string) => {
    setReportId(id);
  };

  return (
    <Form
      onSubmit={onSubmit}
      onBeforeSubmit={() => form.clearErrors()}
      form={form}
    >
      <div className="flex flex-wrap">
        <h2 className='h-40 t-40'><strong>Loan Product Source</strong></h2>
        <SourceRowUw 
        report_id={reportId}
        item={item}
        onSelectedFileIdsChange={handleSelectedFileIdsChange}
        onSelectedIdChange={handleUpdatedId}
        updateSuggestedPrompts={updateSuggestedPrompts}
        />
        <div className="items-center text-xs w-[100%]">
          <FormSelect
            size="sm"
            name="income_type"
            selectionMode="single"
            required
            placeholder={trans({ message: 'Select Income Type' })}
            className="w-150 mb-10"
            // onSelectionChange={(val) => {
            //   changeInstruction(val.toString());
            // }}
          >
            {income_types?.map((income_type: string) => (
            <Item value={income_type} key={income_type}>
              <Trans message={income_type} />
            </Item>
            ))}
          </FormSelect>

          <UWDemoFile onDrop={onDrop}/>
        </div>
        <div  className="items-center text-xs w-[100%]">
        {status && status != 'Completed' && percentage < 100 && (
          <>
            <ProcessingProgressBar percentage={percentage} color={percentage && percentage > 50 ? (status == 'Completed' ? 'orange':'yellow') : (percentage == 50 ? 'green': 'grey')}/>
            <span className='text-green'>{percentage}%</span> - <span className='text-green'>{status}</span>
          </>
        )}
        </div>
        <div className="text-md w-full m-10 flex justify-center">
          <Button
            variant="flat"
            color="green"
            type="submit"
            disabled={isLoading || !isDirty ||  files.length == 0 || selectedFileIds.length == 0}
          >
            <Trans message="Underwriting" />
          </Button>
        </div>
        
      </div>
    </Form>
  );
}


function UWDemoFile({onDrop}: {onDrop: any}) {

  const max_file_upload = 10;

  const extensions = ['pdf', 'xml'];
  const [accepts, setAccepts] = useState<any>({});

  extensions?.forEach((extension:string) => {
    let ext = 'application/'+extension;
    if (extension == 'xml') { 
      ext = 'text/'+extension;
      accepts['application/'+extension] = [];
    } else if (extension == 'html' || extension == 'csv') { 
      ext = 'text/'+extension;
    } else if (extension == 'pdf' || extension == 'json') { 
      ext = 'application/'+extension;
    } else if (extension == 'doc') { 
      ext = 'application/msword';
    } else if (extension == 'docx') { 
      ext = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else if (extension == 'xlsx') { 
      ext = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (extension == 'jpeg' || extension == 'jpg') { 
      ext = 'image/jpeg';
    } else if (extension == 'png') { 
      ext = 'image/x-png';
    }
    accepts[ext] = [];
  });


  const {
    acceptedFiles,
    getRootProps,
    getInputProps
  } = useDropzone({
    accept: accepts ? accepts : {
      'application/pdf': [],
    },
    onDrop,
    maxFiles: max_file_upload,
    multiple: true
  });

  return (
    <section>
      <div {...getRootProps({ className: 'dropzone h-200' })}>
        
        <input name='files' {...getInputProps()} />

        <p>Drag 'n' drop one file here, or click to select template</p>
        <em>(Only <strong>{extensions?.join(", ")}</strong> will be accepted and {max_file_upload} file are the maximum number of one file you can drop here)</em>
      </div >
        <div>
        <h4 className='h-40 t-40'><strong>Uploaded file</strong></h4>
        <div className="table-wrp block flex flex-col overflow-y-scroll">
          <table className="w-full file">
            <thead className="bg-white border-b sticky top-0 bg-slate-300">
              <tr className='bg-gray-300'>
                <th scope="col" className="bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 pl-20 text-left">
                  File Name
                </th>
                <th scope="col" className="bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left">
                  Size
                </th>
                {/* <th scope="col" className="bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left">
                  Status
                </th> */}
                {/* <th></th> */}
              </tr>
            </thead>
            <tbody className="h-96 overflow-y-auto">
              {acceptedFiles.map((file: FileWithPath, index) => (
                <tr key={file.path} className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100">
                  <td className="text-sm font-extrabold text-gray-900 font-light px-6 py-4 pl-20 whitespace-nowrap">
                  {index+1}. {file.path}
                  </td>
                  <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">{formatBytes(file.size)}</td>
                </tr>
              ))}

              
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}



interface ProgressBarProps {
  percentage?: number;
  color?: string;
}

export const ProcessingProgressBar: React.FC<ProgressBarProps> = ({
  percentage = 50,
  color = 'yellow',
}) => {
  const isComplete = percentage === 100;
  const barStyle = {
    width: `${percentage}%`,
    height: '100%',
    backgroundColor: color,
    borderRadius: '9999px',
    ...(isComplete
      ? {}
      : {
          background: `linear-gradient(to right, ${color}, ${color})`,
          animation: 'processing 2s infinite linear',
        }),
  };

  return (
    <div className="w-full max-w-sx mx-auto p-4">
      <div className="bg-orange-100 h-10 rounded-full overflow-hidden border border-gray-300">
        <div className="h-full rounded-full" style={barStyle} />
      </div>
    </div>
  );
};